var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.692 19.3911L12.5682 14.9717C12 15.4589 11.3466 15.8445 10.6079 16.1287C9.86925 16.4129 9.08324 16.5549 8.24988 16.5549C6.18542 16.5549 4.43839 15.7885 3.0088 14.2556C1.57921 12.7227 0.864039 10.8505 0.863281 8.6388C0.863281 6.42634 1.57846 4.55407 3.0088 3.02199C4.43915 1.48991 6.18618 0.723468 8.24988 0.722656C10.3143 0.722656 12.0614 1.4891 13.491 3.02199C14.9205 4.55488 15.6357 6.42715 15.6365 8.6388C15.6365 9.53191 15.5039 10.3743 15.2387 11.1659C14.9736 11.9575 14.6137 12.6578 14.1592 13.2667L18.2829 17.6861L16.692 19.3911ZM8.24988 14.1192C9.67038 14.1192 10.878 13.5862 11.8727 12.5201C12.8675 11.4541 13.3644 10.1603 13.3637 8.6388C13.3637 7.11647 12.8663 5.82228 11.8716 4.75624C10.8769 3.6902 9.66962 3.15758 8.24988 3.15839C6.82938 3.15839 5.62177 3.69141 4.62704 4.75745C3.63231 5.8235 3.13532 7.11728 3.13608 8.6388C3.13608 10.1611 3.63345 11.4553 4.62817 12.5214C5.6229 13.5874 6.83014 14.12 8.24988 14.1192Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.47e84e1293f816a8bc3223425dde6cc4.svg";
export { ForwardRef as ReactComponent };